import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage, auth } from '../config/firebase';

export class StorageService {
    private static instance: StorageService;

    private constructor() { }

    public static getInstance(): StorageService {
        if (!StorageService.instance) {
            StorageService.instance = new StorageService();
        }
        return StorageService.instance;
    }

    /**
     * Upload a file to Firebase Storage
     * @param file The file to upload
     * @param path The path in storage (e.g. 'attachments/nodeId/filename')
     * @returns The download URL
     */
    async uploadFile(file: File | Blob, path: string): Promise<string> {
        try {
            const user = auth.currentUser;
            if (!user) throw new Error('User not authenticated');

            // Add user ID to path for security/isolation
            const fullPath = `users/${user.uid}/${path}`;
            console.log('Starting upload to path:', fullPath);
            const storageRef = ref(storage, fullPath);

            await uploadBytes(storageRef, file);
            console.log('Upload bytes successful, getting download URL...');
            const downloadURL = await getDownloadURL(storageRef);
            console.log('Download URL retrieved:', downloadURL);

            return downloadURL;
        } catch (error) {
            console.error('CRITICAL: StorageService uploadFile failed:', error);
            throw error;
        }
    }

    /**
     * Delete a file from Firebase Storage
     * @param path The path in storage
     */
    async deleteFile(path: string): Promise<void> {
        try {
            const user = auth.currentUser;
            if (!user) throw new Error('User not authenticated');

            // Path in DB might be the full URL, we need the reference path
            // Note: This is simplified. In a real app, you might store the storage path separately.
            const storageRef = ref(storage, path);
            await deleteObject(storageRef);
        } catch (error) {
            console.error('Error deleting file:', error);
            // We don't throw here to avoid blocking UI if deletion fails
        }
    }
}

export const storageService = StorageService.getInstance();
